export type CategorizedFinancialItems<T> = {
    completed: T[];
    pending: T[];
};

export function categorizeFinancialItems<T>(
    items: T[],
    predicate: (item: T) => boolean
): { completed: T[]; pending: T[] } {
    return items
        ? {
              completed: items.filter((item) => !predicate(item)),
              pending: items.filter(predicate),
          }
        : { completed: [], pending: [] };
}
